import axios from 'axios';

export const getSfAuthJWT = () => {
  return axios.get(`/sf_auth`);
};
